import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import usePost from "../../Hooks/usePost";
import { Domain, Workspace } from "../../path";
import { Set_Loader } from "../../Redux/Action/LoaderAction";
import { useDispatch } from "react-redux";
const Editprofile = ({
  EditprofileModal,
  setEditprofileModal,
  Profiledetails,
  setProfiledetails,
}) => {
  const Dispatch = useDispatch();
  const Editprofile_post = usePost(
    `${Workspace[Domain].API_Path}/edit_profile`
  );
  const EditProfile_Submit = () => {
    if (
      Profiledetails?.teacher_name == "" ||
      Profiledetails?.teacher_name == null
    ) {
      toast.error("Kindly enter teacher name");
      toast.clearWaitingQueue();
      return;
    }
    if (
      Profiledetails?.users_email == "" ||
      Profiledetails?.users_email == null
    ) {
      toast.error("Kindly enter teacher email");
      toast.clearWaitingQueue();
      return;
    }
    Editprofile_post.Postcall({
      teacher_name: Profiledetails?.teacher_name,
      teacher_email: Profiledetails?.users_email,
    });
  };
  useEffect(() => {
    if (Editprofile_post.Post != null) {
      switch (Editprofile_post.Post.status) {
        case 200:
          Dispatch(Set_Loader(false));
          toast.success("Saved successfully");
          toast.clearWaitingQueue();
          setEditprofileModal(false);
          break;

        default:
          break;
      }
    }
  }, [Editprofile_post.Post]);

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Edit profile"
        visible={EditprofileModal}
        style={{ maxWidth: "400px", background: "white" }}
        onHide={() => setEditprofileModal(false)}
        contentStyle={{ width: "400px" }}
      >
        <div className="w-[100%]">
          <div className="flex flex-col mt-1">
            <label htmlFor="" className="font-semibold">
              Name
            </label>
            <input
              type="text"
              onInput={(e) => {
                setProfiledetails((prev) => ({
                  ...prev,
                  teacher_name: e.target.value,
                }));
              }}
              value={Profiledetails?.teacher_name}
              placeholder="Enter your name"
              className="border py-1 px-2 my-1"
            />
          </div>
          <div className="flex flex-col mt-1">
            <label htmlFor="">Phone number</label>
            <input
              type="number"
              value={Profiledetails?.users_mobile}
              disabled
              placeholder="Enter your mobile no"
              className="border py-1 px-2 my-1"
            />
          </div>
          <div className="flex flex-col mt-1">
            <label htmlFor="">Email address</label>
            <input
              type="email"
              onInput={(e) => {
                setProfiledetails((prev) => ({
                  ...prev,
                  users_email: e.target.value,
                }));
              }}
              value={Profiledetails?.users_email}
              placeholder="Enter your email"
              className="border py-1 px-2 my-1"
            />
          </div>
          <div className="flex justify-center">
            <button
              className="bg-[#2da3dc] mx-2  text-[white] font-semibold mt-3 px-5 py-1 rounded-sm"
              onClick={() => {
                setEditprofileModal(false);
              }}
            >
              Close
            </button>
            <button
              onClick={EditProfile_Submit}
              className="bg-[#2da3dc] mx-2  text-[white] font-semibold mt-3 px-5 py-1 rounded-sm"
            >
              Save
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default Editprofile;
